import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import  {showmesage}  from './message';
import {getaminities} from './Viewaminities';
import {stasticmsg} from './messagestatic';
import Register from './Register';
import Home from './Home';
import {unmountComponentAtNode} from 'react-dom';
import {postapplyads} from './Viewpostapply';

export const tblcols = (tbldata: any) => {
 let cols = [''];
   if(tbldata != null){
 	if(tbldata.length > 0){
 		const ks = Object.keys(tbldata[0])
 		cols = ks;  
		}
    }
  return cols;
};
export const tblrows = (tbldata: any) => {
 let rows = [['']];
  let cols = ['']; 
  
   if(tbldata != null){
 	cols = tblcols(tbldata);
        tbldata.forEach((rw: any)=>{
         let row = [''];
        cols.forEach((col)=>{
	   row.push(rw[col]);
	   });
         rows.push(row);
      });
    }
  return rows;
};
export const amini = (railway: any,busstop:any,hospital:any,school:any) => {
  let msgdisplay = true;
	
         const sl = getaminities(railway,busstop,hospital,school);
        const Pdiv = document.getElementById('customemsgdiv') as HTMLElement;
	if(Pdiv)unmountComponentAtNode(Pdiv);
	ReactDOM.render(sl,Pdiv);

	Pdiv.style.display = 'block';

  return msgdisplay;
	
};
export const apply = () => {
  let msgdisplay = true;
	
         const apl = postapplyads();
        const Pdiv = document.getElementById('customemsgdiv') as HTMLElement;
	if(Pdiv)unmountComponentAtNode(Pdiv);
	ReactDOM.render(apl,Pdiv);

	Pdiv.style.display = 'block';

  return msgdisplay;
	
};
 
export const getmessage = (mdatau: any,cod: any) => {
  let msgdisplay = true;
	
        const sl = showmesage(mdatau,cod);
        const Pdiv = document.getElementById('customemsgdiv') as HTMLElement;
	if(Pdiv)unmountComponentAtNode(Pdiv);
	ReactDOM.render(sl,Pdiv);

	Pdiv.style.display = 'block';

  return msgdisplay;
	
};
export const getstacmessage = (mdatau: any,cod: any) => {
  let msgdisplay = true;
	
        const sl = stasticmsg(mdatau,cod);
        const Pdiv = document.getElementById('customemsgdiv') as HTMLElement;
	if(Pdiv)unmountComponentAtNode(Pdiv);
	ReactDOM.render(sl,Pdiv);

	Pdiv.style.display = 'block';

  return msgdisplay;
	
};

export const clsmsg = () => {
  let msgdisplay = true;
	
         
        const Pdiv = document.getElementById('customemsgdiv') as HTMLElement;
	if(Pdiv){
		Pdiv.style.display = 'none';
		unmountComponentAtNode(Pdiv);
	}

	

  return msgdisplay;
	
};

export const wrongmsg = () => {
  let msgdisplay = true;
	getmessage('something went wrong','');
        
  return msgdisplay;
	
};
export const unauthomsg = () => {
  let msgdisplay = true;
	getmessage('First time signup -> authorize login','');
        
  return msgdisplay;
	
};
export const getusertype = (utype: any) => {
  let utp = ' ';

	if(utype == 'S'){
	 utp = 'Super Admin';
	}
	else if(utype == 'A'){
	utp = 'Admin';
        }
	else if(utype == 'G'){
	utp = 'General';
        }
	else if(utype == 'M'){
	utp = 'Member';
        }
	else if(utype == 'C'){
	utp = 'Company';
        }
	else if(utype == 'O'){
	utp = 'Official';
        }
	else if(utype == 'P'){
	utp = 'Partner';
        }
	else if(utype == 'E'){
	utp = 'Agent';
        }
  return utp;
	
};

export const sendpostnow = (code: any,oid: any)=>{

	

};
export const arrprtojson = (data: any)=>{

let ardt = [[118,"HDEH163",24,2,1,1,1,1,"The first title entry","","New","0.0000",0,0,0,"Owner","Free Hold","1,3,4,5","Vrfy","08767565434","0.00","Thu, 08 May 2025 00:00:00 GMT",0,1,",,,","",""]]
let arrobj = [{
id:"",code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
}];

ardt = data;	

        for(let i = 0;i<ardt.length;i++){
	
	  let ks = {
id:"",code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
};
	
	
	
	}
  
  if(arrobj.length > 1)
	arrobj.shift();
  return arrobj;
	

};

export const arrpa = (data: any)=>{

let ardt = [[118,"HDEH163",24,2,1,1,1,1,"The first title entry","","New","0.0000",0,0,0,"Owner","Free Hold","1,3,4,5","Vrfy","08767565434","0.00","Thu, 08 May 2025 00:00:00 GMT",0,1,",,,","",""]]
let arrobj = [{
id:"",code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
}];

ardt = data;	

        for(let i = 0;i<ardt.length;i++){
	
	  let ks = {};
	
	}
  
  if(arrobj.length > 1)
	arrobj.shift();
  return arrobj;
	

};

export const searchpostnow = (srargs: any)=>{

	

};
export const clsprofilediv = ()=>{
// const Pdivc = document.getElementById('profilediv') as HTMLElement;
// Pdivc.style.display = 'none';
}
export const toggleitm = (tv: any)=>{
  if(tv) return false;
  else return true;	
}

export const reducearray=(arr: any)=>{
     let farr = [{}];
      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i][0];
		 
		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 1) farr.shift();
	return farr;
      };	

export const sortarray=(arr: any,skey: any)=>{
     let farr = [{
id:"",code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
}];
      if(arr){
		farr = arr;
	     if(farr.length > 0){
		if(skey == 'price')
		farr.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
		else if(skey == 'area')
		farr.sort((a, b) => parseInt(a.area) - parseInt(b.area));
	    }
	 }
	//if(farr.length > 1) farr.shift();
	return farr;
      };	

export const sortarraydsc=(arr: any,skey: any)=>{
     let farr = [{
id:"",code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
}];
      if(arr){
		farr = arr;
	     if(farr.length > 0){
		if(skey == 'price')
		farr.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
		else if(skey == 'area')
		farr.sort((a, b) => parseInt(b.area) - parseInt(a.area));
	    }
	 }
	//if(farr.length > 1) farr.shift();
	return farr;
      };

export const filterpostedby=(arr: any,skey: any)=>{
     let farr = [{
id:"",code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
}];
 let fltrarr = [{
id:"",code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
}];
      if(arr){
		farr = arr;
	    if(skey){
	     if(farr.length > 0){
		
		for(let i =0;i< farr.length;i++){
                
                 const rv = farr[i];
		
		 if(rv["isowner"] == skey)
		 fltrarr.push(rv);
		 
		}
	      }
	    }
	 }
	if(fltrarr.length > 1) fltrarr.shift();
	return fltrarr;
      };

export const getutypebyid = (id: any)=>{
  let usertype = "";
  if(id){
	if(id == "1") usertype = "Super Admin";
	else if(id == "2") usertype = "Admin";
	else if(id == "3") usertype = "partner";
	else if(id == "4") usertype = "staff";
	else if(id == "5") usertype = "Agent";
	else if(id == "6") usertype = "Company";
	else if(id == "7") usertype = "Member";
	else if(id == "8") usertype = "General";


   }	
  return usertype;
}
export const getptypebyid = (id: any)=>{
  let usertype = "";
  if(id){
	if(id == "1") usertype = "Brn";
	else if(id == "2") usertype = "Slv";
	else if(id == "3") usertype = "Gid";
	else if(id == "4") usertype = "Emr";
	else if(id == "5") usertype = "Dim";
	


   }	
  return usertype;
}
export const getaply = (id: any)=>{
  let usertype = "";
  if(id){
	if(id == "1") usertype = "Apl";
	else if(id == "2") usertype = "Rjc";
	else if(id == "3") usertype = "Join";
	
	


   }	
  return usertype;
}


export const clearform=(frmname: any)=> {
 let valid = true;
  try{
	if(frmname){
        const frm = document.getElementById(frmname) as HTMLFormElement;
	if(frm) frm.reset();        
	}
	else{
	valid = false;
	}
    }
    catch(er:any){
	valid = false;
    }
   return valid;	
};
export const displayprofile=()=>{
	const elesrch = <Register />
		const Pdcivr = document.getElementById('profilediv') as HTMLElement;
		if(Pdcivr){
			ReactDOM.render(elesrch,Pdcivr);
			Pdcivr.style.display = 'block';
		}
	
	const homemain = document.getElementById('container') as HTMLElement;
	if(homemain)	homemain.style.display = 'none';
		

   }
export const displaymaindiv=()=>{
	const elesrch = <Home />
		const Pdcivr = document.getElementById('container') as HTMLElement;
		if(Pdcivr){
			ReactDOM.render(elesrch,Pdcivr);
			Pdcivr.style.display = 'block';
		}
	
	      const Profilediv = document.getElementById('profilediv') as HTMLElement;
		if(Profilediv) Profilediv.style.display = 'none';

	

   }


export const removedupliate=(arrv:any)=>{
	

	 const seen = new Set();
const uniquearr= arrv.filter((item:any) => {
  const isDuplicate = seen.has(item.uid);
  seen.add(item.uid);
  return !isDuplicate;
});
return uniquearr;	
}

  export const setuserpoints=(points: any)=> {
 let valid = true;
  try{
	if(points){
	
        const userinf = localStorage.getItem("userinfo");
	 if(userinf){
	  
         const objuserstr = userinf.toString();
          let userinfjson = JSON.parse(objuserstr);
	  userinfjson["upoints"] = points;
	  const stobjstr = JSON.stringify(userinfjson);
	  localStorage.setItem("userinfo",stobjstr);
	 }       
	}
	else{
	valid = false;
	}
    }
    catch(er:any){
	valid = false;
    }
   return valid;	
};
export const getpls = (lid: any)=>{
  let localities = "NA";
     
  if(lid){
    const strlocalstore = localStorage.getItem("localplaces");
     if(strlocalstore){
	let ldata = {localid:0,data:"" };
	
	ldata = JSON.parse(strlocalstore);
	
	if(ldata){
	 if(ldata.localid == parseInt(lid)) localities = ldata.data;

	}
        
     }	
   }	
  return localities;
};
export const setpls = (lid: any,dat: any)=>{
  let isvalid = true;
  if(lid){
	if(dat){
		const localid = parseInt(lid);
		
		let ldata = JSON.stringify({localid:localid,data:dat});
		
		localStorage.setItem("localplaces",ldata);
	}
	else{
	isvalid  = false;
	}
   }	
  return isvalid;
}
export const gtlclstor = (lid: any)=>{
  let localvalue = "";
  if(lid){
	const strstore = localStorage.getItem("userinfo");
	if(strstore){
	const struserinfo = JSON.parse(strstore);
	if(struserinfo[lid]) localvalue = struserinfo[lid]; 
	}
   }	
  return localvalue;
}

		